import { ReactComponent as RightArrow } from '../../../../assets/rightarrow.svg'
import { formatDateForInput } from '../../../../util/formatDate'
import './DateRangePicker.scss'

/** @param {import('./Form.types').DateRangePickerProps} props */
export const DateRangePicker = ({ from, to, onChangeFrom, onChangeTo }) => {
  return (
    <div className='date-picker'>
      <div className='date-picker-item-input'>
        <input id='date-picker-range-from' value={from ? formatDateForInput(from) : from} className='form-settings-date-picker from' type='date' onChange={onChangeFrom} />
        <RightArrow className='date-picker-arrow' />
        <input id='date-picker-range-to' value={to ? formatDateForInput(to) : to} className='form-settings-date-picker to' type='date' onChange={onChangeTo} />
      </div>
    </div>
  )
}

export default DateRangePicker
